import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import "./css/SignIn.css";
import { getCall, postCall } from "../utils/Network";
import { useTranslation } from "react-i18next";
import useQuery from "../components/hooks/useQuery";
import { useDispatch, useSelector } from "react-redux";
import { addAssociationData, setToken, setAssociateId } from "../slices/signUp";
import scrollToTop from "../components/hooks/ScrollToTop";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import LanguageDropdown from "../components/LanguageDropdown";
import useTokenRefresh from "../hooks/useTokenRefresh";

const ApiKey = process.env.REACT_APP_API_KEY;

export default function Signin() {
  const inputRef = useRef(null);
  const query = useQuery();
  let params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState(query.get("email"));
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [passMessage, setPassMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { token } = useParams();
  const { t } = useTranslation();
  const location = useLocation();
    const { setupTokenRefresh } = useTokenRefresh();

  const myHeaders = { "API-key": ApiKey };

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  // Set Email Function
  const fnSetEmail = (event) => {
    setEmail(event.target.value);
  };

  const fnSetPassword = (event) => {
    setPassword(event.target.value);
  };

  useEffect(() => {
    const html = document.getElementsByTagName("html")[0];
    html.setAttribute("data-wf-page", "68603f7a056ff6f78f58cb16");
    html.setAttribute("data-wf-site", "68603f7a056ff6f78f58cab1");
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require("ix2").init();
    document.dispatchEvent(new Event("readystatechange"));
  }, []);

  useEffect(() => {
    if (token) {
      sessionStorage.setItem("token", token);
    }
  }, [token]);

  // Validate Function

  async function fnLogin() {
    const regEx = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if (email == "") {
      setMessage(t("pleaseEnterYourEmail"));
      return false;
    } else if (!regEx.test(email)) {
      setMessage(t("invalidEmail"));
      return false;
    }

    if (password == "") {
      setPassMessage(t("pleaseEnterYourPassword"));
      return false;
    }

    try {
      const data = { email: email, password: password };

      await postCall({
        url: "generateToken",
        bodyData: {
          ...data,
          ...{ clientId: process.env.REACT_APP_API_CLIENTID },
        },
        header: myHeaders,
      }).then(async (resp) => {
        if (resp?.status == 200 && resp.data.associateId > 0) {
          dispatch(setToken(resp?.data.jwtToken));
          localStorage.setItem("apiToken", JSON.stringify(resp.data));

          setupTokenRefresh();

          const response = await getCall({
            url: "getAssociate",
            urlParams: { associateid: resp.data.associateId },
            header: myHeaders,
          });
          if (response.status === 200) {
            let webAlias = response.data.webAlias[0].alias;
            dispatch(addAssociationData(response?.data));
            dispatch(setAssociateId(response?.data?.associateId));
            localStorage.setItem("associateid", response.data.associateId);
            localStorage.setItem(
              "associateData",
              JSON.stringify(response.data)
            );
            navigate(`/${webAlias}/enrollment-kit`);
          }
        } else {
          setPassMessage(t("invalidUsernamePassword"));
        }
      });
    } catch (error) {
      console.log("error:", error);
    }

    setMessage("");
  }

  const checkKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      fnLogin();
    }
  };

  return (
    <>
      <div className="img-bg">
        <div className="enrollment-navbar">
          <Link to="/"><div className="noa-logo"></div></Link>
          <LanguageDropdown />
        </div>
        <div className="dark-mode">
          <div className="main-join-now">
            <div>
              <div className="heading-enroll">{t("youAlreadyHave")}</div>
              <h2>{t("anAccount")}</h2>
            </div>
            <form action="/enrollment" onSubmit={() => {}}>
              <p className="enter-referral">{t("enterYourEmailAddress")}</p>
              <div className="input-wrapper">
                <div className="errormsg-wrapper">
                  <input
                    onKeyDown={checkKeyPress}
                    type="text"
                    placeholder={t("enterYourEmailAddress")}
                    className="input-join"
                    maxLength={40}
                    value={email}
                    onChange={fnSetEmail}
                    ref={inputRef}
                  />
                  <div className="err-message">
                    <small>{message}</small>
                  </div>
                </div>
                <div className="errormsg-wrapper">
                  <div className="relative">
                    <input
                      onKeyDown={checkKeyPress}
                      type={showPassword ? "text" : "password"}
                      placeholder={t("enterYourPassword")}
                      className="input-join"
                      maxLength={40}
                      onChange={fnSetPassword}
                    />
                    <button
                      type="button"
                      className="toggle-password-btn"
                      onClick={() => setShowPassword((prev) => !prev)}
                      tabIndex={-1}
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </button>
                  </div>
                  <div className="err-message">
                    <small>{passMessage}</small>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div className={`navbar-button-wrapper btn-custom-signup`}>
                  <div className="primary-button-wrapper">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        fnLogin();
                      }}
                      data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                      className="primary-button w-inline-block"
                    >
                      <div className="primary-button-border-wrap">
                        <div className="primary-button-wrap">
                          <div className="primary-button-text">
                            {t("login")} &nbsp;&nbsp;➜
                          </div>
                          <div className="primary-button-hover-text">
                            {t("login")} &nbsp;&nbsp;➜
                          </div>
                          <div className="primary-button-hover-bg"></div>
                        </div>
                      </div>
                      <div className="line-wrap">
                        <div className="primary-line-wrap _1">
                          <div className="line _1"></div>
                          <div className="line _2"></div>
                        </div>
                        <div className="primary-line-wrap _2">
                          <div className="line _3"></div>
                          <div className="line _4"></div>
                        </div>
                        <div className="primary-line-wrap _3">
                          <div className="line _5"></div>
                          <div className="line _6"></div>
                        </div>
                        <div className="primary-line-wrap _4">
                          <div className="line _7"></div>
                          <div className="line _8"></div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="menu-button w-nav-button">
                    <div
                      data-is-ix2-target="1"
                      className="hamburger-menu-icon"
                      data-w-id="b58e0106-6be1-80f9-2e9e-29cc3a30b8aa"
                      data-animation-type="lottie"
                      data-src="/images/hamburger-20menu.lottie"
                      data-loop="0"
                      data-direction="1"
                      data-autoplay="0"
                      data-renderer="svg"
                      data-duration="0"
                      data-ix2-initial-state="0"
                    >
                      <span style={{ color: "#ffffff" }}>
                        <img
                          src="/images/Hamburger_icon.png"
                          alt=""
                          style={{ width: "30%" }}
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
